import React, {useState} from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const BalanceCard = () => {
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
  const fundingBal = useSelector((state) => state.wallet.fundingBalance) || 0;
  const coinRates = useSelector((state) => state.coins.coinRates);
  const [isVisible, setIsVisible] = useState(true);

  const getBTCbalance = () => {
    let bal = 0;
    if (coinRates && coinRates.length > 0) {
      coinRates.forEach(coin => {
        if (coin.symbol === 'BTC') {
          bal = (fundingBal/parseFloat(coin.priceUsd)).toFixed(8);
        }
      });
    }
    return bal || '0.000000';
  }

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  }

  return (
    <Card 
      sx={{ 
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 50%, #1a1a1a 100%)',
        borderRadius: '16px',
        padding: '20px',
        marginTop: '20px',
        marginX: '16px',
        border: '1px solid rgba(255, 255, 255, 0.05)'
      }}
      elevation={0}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '14px',
            fontFamily: 'sans-serif'
          }}
        >
          Wallet Balance
        </Typography>
        <IconButton 
          onClick={toggleVisibility}
          size="small"
          sx={{ color: 'white', padding: '4px' }}
        >
          {isVisible ? <VisibilityIcon sx={{ fontSize: '20px' }} /> : <VisibilityOffIcon sx={{ fontSize: '20px' }} />}
        </IconButton>
      </Box>

      <Box sx={{ marginBottom: '16px' }}>
        <Typography 
          sx={{
            fontWeight: 'bold',
            fontSize: '32px',
            color: 'white',
            fontFamily: 'sans-serif',
            lineHeight: 1.2
          }}
        >
          {isVisible ? formatPrice(fundingBal) : '$••••••'}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '12px',
            fontFamily: 'sans-serif'
          }}
        >
          ≈ {isVisible ? `${getBTCbalance()} BTC` : '•••••• BTC'}
        </Typography>
        <Box 
          sx={{
            backgroundColor: '#4caf50',
            borderRadius: '8px',
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          <ArrowUpwardIcon sx={{ fontSize: '14px', color: 'white' }} />
          <Typography 
            sx={{
              fontSize: '12px',
              color: 'white',
              fontFamily: 'sans-serif',
              fontWeight: '500'
            }}
          >
            +0.00%
          </Typography>
        </Box>
      </Box>
    </Card>
  )
}

export default BalanceCard
